module.exports = __webpack_public_path__ + "static/img/13.8297380.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/13.png
// module id = lfAR
// module chunks = 0